import React from 'react';
import { Modal as AntDesignModal } from 'antd';
import './styles.css';

const Modal = ({ className, ...props }) => {
  return <AntDesignModal {...props} className={['cb-modal', className || '']} />;
};

export default Modal;
